import { render, staticRenderFns } from "./MspCalendarioSettimana.vue?vue&type=template&id=58ca114a"
import script from "./MspCalendarioSettimana.vue?vue&type=script&lang=js"
export * from "./MspCalendarioSettimana.vue?vue&type=script&lang=js"
import style0 from "./MspCalendarioSettimana.vue?vue&type=style&index=0&id=58ca114a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports